import { Container3D } from "pixi3d/pixi7";

// TODO egorja: extention, not static functions
export class Container3DExtentions {
    public static findByName<T extends Container3D>(container: Container3D, name: string): T {
        for (const child of container.children) {
            if (!(child instanceof Container3D)) {
                continue;
            }
            if (child.name === name) {
                return child as T;
            }
            const item = this.findByName<T>(child, name);
            if (item != null) {
                return item;
            }
        }
        return null;
    }
}
